import { render, staticRenderFns } from "./OsmStats.vue?vue&type=template&id=5ddf61ca&scoped=true"
import script from "./OsmStats.vue?vue&type=script&lang=js"
export * from "./OsmStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf61ca",
  null
  
)

export default component.exports